import React from 'react';
import { Container } from '../../components/Layout/Layout';
import { IconCollection } from '../../components';
import css from './ListingTopbar.module.css'

const ListingTopbar = ({ history }) => {
  const goBack = () => {
    history.goBack(); // Go back to the previous page
  };

    const copyCurrentPageUrl = () => {
        const url = window.location.href;
      
        // Copy to clipboard
        navigator.clipboard.writeText(url).then(() => {
            alert('URL copied to clipboard!');
        }).catch(err => {
          console.error('Failed to copy URL:', err);
        });
      
        return url;
      };
      
    return (
       <Container className={css.container}>
         <div className={css.topbarContent}>
            <button className={css.backButton} type="button" onClick={goBack}><IconCollection name="backArrow"/></button>
            <div className={css.rightButtons}>
                  <button type="button" onClick={copyCurrentPageUrl}><IconCollection name="shareIcon"/></button>
                    {/* <button type="button"><IconCollection name="heartIcon"/></button> */}
            </div>
        </div>
       </Container>
    );
};

export default ListingTopbar;